import { parsePhoneNumber } from "libphonenumber-js";

export function normalizePhoneString(value: unknown): string {
	if (value === null || value === undefined) return "";
	let str = String(value).trim();
	if (!str) return "";

	// Handle scientific notation, e.g. "9.72547E+11", "9.72547e+11", 9.72547e11
	if (/[eE][+-]?\d+/.test(str)) {
		const num = Number(str);
		if (Number.isFinite(num)) {
			str = BigInt(Math.round(num)).toString();
		}
	}

	// Handle weird case where + is at the end
	if (str.endsWith("+")) {
		str = "+" + str.slice(0, -1);
	}

	return str;
}

export const formatPhoneNumber = (value: unknown): string => {
	const cleaned = normalizePhoneString(value);
	if (!cleaned) return "";

	try {
		const phoneNumber = parsePhoneNumber(cleaned);
		if (phoneNumber && phoneNumber.isValid()) {
			return phoneNumber.formatInternational();
		}
	} catch {
		// ignore
	}

	if (!cleaned.startsWith("+")) {
		try {
			const phoneNumberWithPlus = parsePhoneNumber("+" + cleaned);
			if (phoneNumberWithPlus && phoneNumberWithPlus.isValid()) {
				return phoneNumberWithPlus.formatInternational();
			}
		} catch {
			// ignore
		}

		try {
			const phoneNumberIL = parsePhoneNumber(cleaned, "IL");
			if (phoneNumberIL && phoneNumberIL.isValid()) {
				return phoneNumberIL.formatInternational();
			}
		} catch {
			// ignore
		}
	}

	return cleaned;
};

export function formatPhoneNumberList(values: unknown[]): string {
	return values.map(formatPhoneNumber).filter(Boolean).join(", ");
}

export function isPhoneKey(key?: string | null): boolean {
	if (!key) return false;
	const lower = key.toLowerCase();
	return (
		lower.includes("phone") ||
		lower.includes("mobile") ||
		lower.includes("cell") ||
		lower === "to" ||
		lower === "from"
	);
}
